export enum LanguageType {
    'en-GB' = 1,
    'de-DE',
}

export enum LanguageCode  {
    ENGLISH = 'en-GB',
    GERMAN = 'de-DE'
}
